import VehicleVisitContainer from "../../../Component/Application/VehicleVisit/VehicleVisitContainer";
const VehicleVisitPage = () => {
    return (
        <div className="page-body">
            <VehicleVisitContainer />
        </div>
    );
};

export default VehicleVisitPage;